import { list } from "./devices-list-screen.js";
import { scanning } from "./devices-scanning-screen.js";

export default {
	list,
	scanning
}